import React, { useRef, useState } from 'react';
import qs from 'query-string';
import ReCAPTCHA from 'react-google-recaptcha';
import { Redirect, Link } from 'react-router-dom';
import { Form, Row, Col, Image, Alert } from 'react-bootstrap';

import './Auth.css';

import { Http } from '../../support';
import ByPactopia from './ByPactopia';
import { FormControl } from '../../facturotopia';
import LoadingButton from '../../facturotopia/LoadingButton';
import { useAsync } from '../../facturotopia/hooks/useAsync';
import { useValidator } from '../../facturotopia/hooks/useValidator';

const rules = (data) => {
  return {
    rfc: ['required', 'string', 'min:12', 'max:13', 'regex:/^[A-Z&Ñ]{3,4}[0-9]{2}(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])[A-Z0-9]{2}[0-9A]$/'],
    nss: [data.tipo !== 'cliente' ? 'required' : 'nullable', 'numeric' , 'regex:/^[0-9]{11}$/'],
    email: [data.tipo === 'cliente' ? 'required' : 'nullable', 'string', 'email']
  }
}

const AuthExternalSearhDomain = (props) => {
  const query = qs.parse(props.location.search);

  const { bind, values, handleSubmit } = useValidator(
    rules({ tipo: query.tipo }),
    {
      tipo: query.tipo
    },
    {},
    {
    onChange: () => handleOnChange
  })

  const { busy, dispatch, error, result } = useAsync()

  const [state, setState] = useState({
    challenge: '',
    tipo: query.tipo
  })

  const recaptchaRef = useRef();

  const submit = async () => {
    const challenge = await recaptchaRef.current.executeAsync();

    const params = {
      challenge,
      ...values,
      tenancy: query.tenancy
    }

    const headers = {
      'X-Tenancy': query.tenancy
    }

    return await Http.post('/ext/receptores/external', params, { headers });
  }

  const handleOnSubmit = async () => {
    dispatch(() => submit())
  }

  const handleOnChange = () => {
  }

  const onCaptchaChange = (value) => {
    setState({
      ...state,
      challenge: value
    });
  }

  const renderForm = () => {
    const { tipo } = state;

    return (
      <Form autoComplete="off">
        <div className="login-content">
          <div className="pb-3">
            <h6 className="text-muted">
              {tipo !== 'cliente' && 'Búsqueda de portal de Empleado'}
              {tipo === 'cliente' && 'Búsqueda de portal de Facturas'}
            </h6>
          </div>

          <Row>
            <Col>
              Para ayudarte a encontrar tu portal de {tipo !== 'cliente' ? 'Empleado' : 'Facturas'} ingresa la siguiente información.
            </Col>
          </Row>

          <div className="form-box mt-4">
            <FormControl type="text"
              label="RFC"
              traslate="no"
              placeholder="Ingresa tu RFC a 13 dígitos"
              autoFocus={ true }
              {...bind('rfc')}
            />

            {tipo !== 'cliente' && (
              <FormControl type="text"
                label="Número de Seguridad Social"
                placeholder="Ingresa tu NSS a 11 dígitos"
                {...bind('nss')}
              />
            )}

            {tipo === 'cliente' && (
              <FormControl type="text"
                label="Email"
                placeholder="Ingresa tu correo electrónico"
                {...bind('email')}
              />
            )}

            <ReCAPTCHA
              size="invisible"
              ref={ recaptchaRef }
              sitekey={ process.env.REACT_APP_RECAPTCHA_KEY }
              onChange={ onCaptchaChange }
            />

            { !!error && (
              <div className="pt-2">
                <p className="text-danger">
                  Verifica tu información e intenta nuévamente
                </p>
              </div>
            ) }

            {!!error && tipo !== 'cliente' && (
              <Row className="mt-4">
                <Col>
                  <Alert variant="danger">
                    <div>
                      Comunícate con el departamento de Recursos Humanos de tu empresa para solicitar tu RFC y Número de Seguridad Social antes de intentar nuévamente.
                    </div>
                  </Alert>
                </Col>
              </Row>
            )}

            {!!error && tipo === 'cliente' && (
              <Row className="mt-4">
                <Col>
                  <Alert variant="danger">
                    <div>
                      Comunícate con la empresa para solicitar tu RFC e Email con el que solicitaste tu factura antes de intentar nuévamente.
                    </div>
                  </Alert>
                </Col>
              </Row>
            )}

            <Row className="my-4">
              <Col className="text-right">
                <LoadingButton type="button"
                  block={ true }
                  loading={ busy }
                  onClick={ handleSubmit(handleOnSubmit) }
                >
                  { busy && 'Buscando...'}
                  { !busy && 'Buscar' }
                </LoadingButton>
              </Col>
            </Row>

            <Row>
              <Col className="text-right">
                <Link to={`/auth/login${query.tenancy ? '?tenancy=' + query.tenancy: ''}`}>
                  Iniciar sesión
                </Link>
              </Col>
            </Row>

          </div>
        </div>

        <Row className="pt-4 pb-3">
          <Col>
            <small className="text-muted">
              Al continuar aceptas nuestros <a href="/">Términos del servicio</a> y nuestro <a href="/">Acuerdo de privacidad</a>
            </small>
          </Col>
        </Row>
      </Form>
    )
  }

  const renderDomains = () => {
    return result.data.map((value) => {
      return (
        <div className="mt-4" key={value.id}>
          <a href={value.url} rel="noopener noreferrer" className="" target="_blank">
            Ir a {value.cliente}
          </a>
        </div>
      )
    })
  }

  const renderResult = () => {
    const { tipo } = state;

    if (!result.data?.length) {
      if (tipo ===  'cliente') {
        return (
          <div className="my-4">
            La información que nos proporcionaste no coincide con algún registro en nuestra plataforma, por favor revisa el correo electrónico que registraste en al solicitar tu factura e intenta acceder nuevamente.
          </div>
        )
      }

      return (
        <div className="my-4">
          La información que nos proporcionaste no coincide con algún registro en nuestra plataforma, por favor comunícate con el departamento de <strong>Recursos Humanos</strong> para solicitar la información e intenta acceder nuevamente.
        </div>
      )
    }

    return (
      <div className="my-4">
        Para acceder a tu portal de empleado solo haz click sobre el enlace, después guarda la url en favoritos para que puedas acceder con más facilidad.

        <br />
        <br />

        ¡Suerte!

        {renderDomains()}
      </div>
    )
  }

  const {
    isLoggedIn,
  } = {};

  if (isLoggedIn) {
    let { from } = props.location.state || { from: { pathname: '/app/dashboard' } };

    if (from.pathname === '/auth/login') {
      from.pathname = '/app/dashboard';
    }

    return <Redirect to="/bridge" state={ from } />;
  }

  return (
    <div className="auth-content RegistroBridge">
      <div className="avatar mt-4">
        <div className="auth-logo">
          <div className="d-flex justify-content-start">
              <Image src="/img/logo.png"
                className="auth-logo-img opacity-6"
                fluid={ true }
              />
              <p className="title text-muted">Facturotöpia</p>
          </div>
        </div>
      </div>

      {!result && renderForm()}

      {!!result && renderResult()}

      <ByPactopia />
    </div>
  )
}

export default AuthExternalSearhDomain;